import { MetricResponse } from '../interfaces/metric.interface';

export {
  EMPTY_ACCESS_METRICS,
  EMPTY_ACTIVITY_OVERVIEW,
  ENERGY_DISTRIBUTION,
  ENERGY_DISTRIBUTION_OVERAL,
  ENERGY_METRICS,
  ENERGY_METRICS_GRID_CONFIG,
  ENERGY_METRICS_OVERAL_VIEW,
} from '../config/metrics.config';

export const MOCK_ACTIVITY_OVERVIEW = (): MetricResponse => {
  return {
    metrics: [
      {
        type: 'TOTAL_BOOKINGS',
        value: 10,
        valueCalc: 10,
        temporality: 'LAST_WEEK',
      },
      {
        type: 'CANCELLATION_WEEK',
        value: 10,
        valueCalc: 10,
        temporality: 'LAST_WEEK',
      },
      {
        type: 'OCCUPANCY_RATE',
        value: 10,
        valueCalc: 10,
        temporality: 'LAST_MONTH',
      },
      {
        type: 'INCOME_MONTH',
        value: 10,
        valueCalc: 10,
        temporality: 'LAST_MONTH',
      },
    ],
  };
};

export const MOCK_ACCESS_METRICS = (): MetricResponse => {
  return {
    metrics: [
      {
        type: 'SUCCESSFUL_ACCESS',
        value: 15,
        valueCalc: 20,
        temporality: 'LAST_WEEK',
      },
      {
        type: 'FAILED_ACCESS',
        value: 15,
        valueCalc: 7,
        temporality: 'LAST_WEEK',
      },
    ],
    recentActivity: [
      {
        access: '0912',
        activity: 'Abierto salon',
        date: '2026-02-10',
        time: '10:12',
        status: 'SUCCESS',
      },
      {
        access: '1235',
        activity: 'Abierto salon',
        date: '2026-02-07',
        time: '10:12',
        status: 'SUCCESS',
      },
      {
        access: '2345',
        activity: 'Abierto cocina',
        date: '2026-02-05',
        time: '10:12',
        status: 'SUCCESS',
      },
      {
        access: '1253',
        activity: 'Abierto salon',
        date: '2026-02-02',
        time: '10:12',
        status: 'SUCCESS',
      },
    ],
  };
};

export const MOCK_ACCESS_METRICS_OVERAL_VIEW = (): MetricResponse => {
  return {
    metrics: [
      {
        type: 'BATTERY',
        value: 85,
        valueCalc: undefined,
        temporality: 'stable',
      },
      {
        type: 'SUCCESSFUL_ACCESS',
        value: 15,
        valueCalc: 20,
        temporality: 'LAST_WEEK',
      },
      {
        type: 'FAILED_ACCESS',
        value: 15,
        valueCalc: 7,
        temporality: 'LAST_WEEK',
      },
    ],
    recentActivity: [
      {
        access: '0912',
        activity: 'Abierto salon',
        date: '2026-02-10',
        time: '10:12',
        status: 'SUCCESS',
      },
      {
        access: '1235',
        activity: 'Abierto salon',
        date: '2026-02-07',
        time: '10:12',
        status: 'SUCCESS',
      },
      {
        access: '2345',
        activity: 'Abierto cocina',
        date: '2026-02-05',
        time: '10:12',
        status: 'SUCCESS',
      },
      {
        access: '1253',
        activity: 'Abierto salon',
        date: '2026-02-02',
        time: '10:12',
        status: 'SUCCESS',
      },
    ],
  };
};

export const MOCK_PERFORMANCE_METRICS = (): MetricResponse => {
  return {
    metrics: [
      {
        type: 'OCCUPANCY_RATE',
        value: 42,
        valueCalc: 5,
        temporality: 'LAST_MONTH',
      },
      {
        type: 'REVENUE_PER_NIGHT',
        value: 290,
        valueCalc: 12,
        temporality: 'PREVIOUS_MONTH',
      },
      {
        type: 'CANCELLATION_RATE',
        value: 6,
        valueCalc: 2,
        temporality: 'PREVIOUS_MONTH',
      },
      {
        type: 'TOTAL_REVENUE',
        value: 9780,
        valueCalc: 18,
        temporality: 'LAST_YEARS',
      },
      {
        type: 'TOTAL_BOOKINGS',
        value: 27,
        valueCalc: 8,
        temporality: 'LAST_YEARS',
      },
      {
        type: 'AVERAGE_RATING',
        value: 4.8,
        temporality: 'Excellent',
      },
    ],
  };
};
